import React, { useMemo, useRef } from "react";
import Label from "components/general/Label";
import 'styles/sports/fbl.scss';

function draw(context, data, sizeCanvas) {
  const size_canvas = sizeCanvas;
  const img_factor = 1//factor || 2.5; //como ampliamos lo que se ve 
  const img_width = size_canvas * img_factor;
  const image = new Image();
  const centerX = size_canvas / 2;
  const centerY = size_canvas / 2;
  const positions = {
    LW: {
      x: centerX - 300,
      y: centerY - 290
    },
    P: {
      x: centerX,
      y: centerY - 320
    },
    RW: {
      x: centerX + 300,
      y: centerY - 290
    },
    LB: {
      x: centerX - 300,
      y: centerY - 30
    },
    CB: {
      x: centerX,
      y: centerY - 60
    },
    RB: {
      x: centerX + 300,
      y: centerY - 30
    },
    GK: {
      x: centerX,
      y: centerY + 290
    }
  }

  image.src = "/assets/images/pictos/hbl/handball-field.svg";
  image.onload = () => {
    context.drawImage(image, 0, 0, size_canvas, size_canvas, 0, 0, img_width, img_width);
    //const uniform = '#03a9f4'
    let color = data?.eventUnitEntries?.find(item => item?.eue_code === 'UNIFORM')?.eue_value.toLowerCase().split(' ')[0];
    let uniform = UniformFormation(color)
    const radioCircle = 30;
    const boxWidth = 160;
    const boxHeight = 40;


    let players = data?.teamAthletes?.filter(item => item?.eventUnitEntries?.some(eui => eui?.eue_code === 'STARTER'))
    players.forEach(item => {
      let pos = item?.eventUnitEntries?.find(player => player?.eue_code === 'STARTER')?.eue_value
      context.beginPath();
      // line color
      context.fillStyle = 'rgba(0, 0, 0, 0.7)';
      context.strokeStyle = uniform;
      context.lineWidth = 2;
      context.arc(positions[pos]?.x, positions[pos]?.y, radioCircle, 0, 2 * Math.PI);
      context.fill();
      context.stroke();

      context.beginPath();
      context.font = '30px Arial'
      context.fillStyle = 'rgba(255, 250, 255)';
      context.textBaseline = 'middle'
      context.textAlign = 'center'
      context.fillText(item?.bib, positions[pos]?.x, positions[pos]?.y);
      context.fill();

      context.beginPath();
      context.fillStyle = 'rgba(0, 0, 0, 0.7)';
      context.strokeStyle = uniform;
      context.lineWidth = 2;
      context.rect(positions[pos]?.x - (boxWidth / 2), positions[pos]?.y + (radioCircle + 5), boxWidth, boxHeight);
      context.fill();
      context.stroke();

      context.beginPath();
      context.font = '14px Arial'
      context.fillStyle = 'rgba(255, 250, 255)';
      context.textBaseline = 'middle'
      context.textAlign = 'center'
      context.fillText(item?.athlete?.shortName, positions[pos]?.x, positions[pos]?.y + (boxHeight / 2 + radioCircle + 7));// el 7 es la mitad de la fuente de letra del nombre
      context.fill();

      context.beginPath();
      context.font = '25px Arial'
      context.fillStyle = 'rgba(0, 0, 0)';
      context.textBaseline = 'middle'
      context.textAlign = 'center'
      context.fillText(pos, positions[pos]?.x, positions[pos]?.y - (boxHeight / 2 + radioCircle + 7));// el 7 es la mitad de la fuente de letra del nombre
      context.fill();
    });
  }



}

function FildFormation({ data }) {
  const sizeCanvas = 1000
  const canvas = useRef();
  React.useEffect(() => {
    const context = canvas.current.getContext('2d');
    draw(context, data, sizeCanvas);
  });

  return (
    <>
      <div className="row">
        <div className="col text-center formation-text my-3">
          <Label data='HeaderStartingSeven' />
        </div>
      </div>
      <canvas className="field-footbal" ref={canvas} height={sizeCanvas} width={sizeCanvas} />
    </>
  );

}

export default FildFormation;

function UniformFormation(color) {
  let uniform = '#03a9f4'
  switch (color) {
    case 'black':
      uniform = '#000000'
      break;
    case 'silver':
      uniform = '#C0C0C0'
      break;
    case 'grey':
      uniform = '#808080'
      break;
    case 'white':
      uniform = '#FFFFFF'
      break;
    case 'maroon':
      uniform = '#800000'
      break;
    case 'red':
      uniform = '#ff0000'
      break;
    case 'purple':
      uniform = '#800080'
      break;
    case 'fuchsia':
      uniform = '#FF00FF'
      break;
    case 'green':
      uniform = '#008000'
      break;
    case 'lime':
      uniform = '#00FF00'
      break;
    case 'olive':
      uniform = '#808000'
      break;
    case 'yellow':
      uniform = '#FFFF00'
      break;
    case 'navy':
      uniform = '#000080'
      break;
    case 'blue':
      uniform = '#0000FF'
      break;
    case 'teal':
      uniform = '#008080'
      break;
    case 'aqua':
      uniform = '#00FFFF'
      break;
    case 'coral':
      uniform = '#ff7f50'
      break;
    case 'orange':
      uniform = '#ffa500'
      break;
    case 'light':
      uniform = '#add8e6'
      break;
    default:
  }
  return (uniform)
}
